import type { ChainFamily, SignedMessage } from 'src/blockchain';
import type {
  ChallengePurpose,
  ApiSignedChallenge,
  ApiAuthChallengePayload,
} from 'src/types/wallet';

/**
 * The two request bodies of the wallet-ownership proof, built in one place so they cannot drift
 * apart: api binds the challenge to a wallet family when it is issued and verifies the signature
 * with that same family's verifier (api#135). A challenge fetched as TRON and signed as EVM is
 * refused — so `chainType` has to be identical in both, and it is the family of the wallet
 * actually signing, not a property of the installation.
 */

export const buildChallengeRequest = (params: {
  walletAddress: string;
  purpose: ChallengePurpose;
  family: ChainFamily;
}): ApiAuthChallengePayload => ({
  walletAddress: params.walletAddress,
  purpose: params.purpose,
  chainType: params.family,
});

export const buildSignedChallenge = (params: {
  family: ChainFamily;
  address: string;
  publicKey?: string;
  signed: SignedMessage;
}): ApiSignedChallenge => ({
  chainType: params.family,
  publicKey: params.publicKey,
  address: params.address,
  signature: params.signed.signature,
  timestamp: params.signed.timestamp,
  domain: params.signed.domain,
  payload: params.signed.payload,
});
